import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = ({ inventoryLog, endDate, beginDate }) => (

    <div>
        {
            inventoryLog.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    {
                        inventoryLog.length > 0 &&
                        <div className="table-responsive">
                            {
                                inventoryLog.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2" key={index}>
                                            <div className="col-lg-12 title_th">
                                            </div>{/* row - Date */}
                                            <div className="col-lg-12 text-center daily_cash">
                                                <div className="row m-0">
                                                    <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 m-0 p-0 d-flex">
                                                        <div className="col-lg-5 col-md-4 col-sm-12 col-xs-12 m-0 p-0">
                                                            <label>Product name</label>
                                                            <h3 className="m-0 grey-text">{item.productName}</h3>
                                                        </div>
                                                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6 m-0 p-0 m-0 p-0">
                                                            <p><label>SKU:</label> <span>{item.sku}</span></p>
                                                            <p><label>Brand:</label> <span>{item.brand}</span></p>
                                                            <p><label>Species:</label> <span>{item.species}</span></p>
                                                        </div>
                                                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-6 m-0 p-0">
                                                            <p><label>Cannabis:</label> <span>{item.isCannabis ? "Cannabis" : "Non Cannabis"}</span></p>
                                                            <p><label>Category:</label> <span>{item.categoryName}</span></p>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 m-0 p-0 d-flex">

                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                                                            <label>Opening Inventoryy</label>
                                                            <h3 className="m-0">{item.openInventory}</h3>
                                                        </div>
                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0">
                                                            <label>Inventory Change</label>
                                                            <h3 className={`m-0 ${item.inventoryChange < 0 ? "danger" : "green-text"}`}>{item.inventoryChange}</h3>
                                                        </div>
                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0 m-0 p-0">
                                                            <label>Closing Inventory</label>
                                                            <h3 className="m-0">{item.closingInventory}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>{/* Column Icons */}
                                        </div>
                                    );
                                })
                            }
                        </div>
                    }
                </div>
        }
    </div>
);

export default Body;
